export const getCurrentUrl = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const getCurrentPath = () =>
  `${window.location.pathname}${window.location.search}`;

export const getCurrentHash = () => window.location.hash;

export const normalizeAppRoute = (path: string) => {
  if (!path) return '/';
  if (path.startsWith('#/')) return path.slice(1);
  return path;
};

export const navigate = (path: string, replace = false) => {
  const method = replace ? 'replaceState' : 'pushState';
  window.history[method](null, '', normalizeAppRoute(path));
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const normalizeLegacyHashRoute = () => {
  if (window.location.hash.startsWith('#/')) {
    const cleanPath = window.location.hash.slice(1);
    window.history.replaceState(null, '', cleanPath);
  }
};
